import { render, staticRenderFns } from "./mallPicture.vue?vue&type=template&id=3304794c&scoped=true"
import script from "./mallPicture.vue?vue&type=script&lang=js"
export * from "./mallPicture.vue?vue&type=script&lang=js"
import style0 from "./mallPicture.vue?vue&type=style&index=0&id=3304794c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3304794c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Prod-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3304794c')) {
      api.createRecord('3304794c', component.options)
    } else {
      api.reload('3304794c', component.options)
    }
    module.hot.accept("./mallPicture.vue?vue&type=template&id=3304794c&scoped=true", function () {
      api.rerender('3304794c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/upload/mallPicture.vue"
export default component.exports